import _regeneratorRuntime from 'babel-runtime/regenerator';
import _Object$assign from 'babel-runtime/core-js/object/assign';
import _Promise from 'babel-runtime/core-js/promise';
import _asyncToGenerator from 'babel-runtime/helpers/asyncToGenerator';
import _extends from 'babel-runtime/helpers/extends';

import CopyCreative from '@/views/creative/components/copy-creative.vue';
import DownloadAllResources from '@pt/components/download-all-resources/index.vue';
import { mapState } from 'vuex';
import { createPSProject } from '@ps/api/project';
import _ from 'lodash';
import { playsmartEntry } from '@pt/config';

export default {
  name: 'copyCreativeDropdown.vue',

  components: {
    CopyCreative: CopyCreative,
    DownloadAllResources: DownloadAllResources
  },

  data: function data() {
    return {};
  },


  computed: _extends({}, mapState({
    id: function id(state) {
      return state.creative.template.id;
    },
    templateConfig: function templateConfig(state) {
      return state.creative.template.templateConfig || {};
    },
    is_allow_ps: function is_allow_ps(state) {
      return state.user.info.is_allow_ps;
    }
  }), {
    creativeList: function creativeList() {
      var map = {
        'common-template.custom': {
          normal: {
            type: 'normal',
            routerName: 'common-template.custom'
          }
        }
      };

      return map[this.$route.name];
    },
    dropdownAttrs: function dropdownAttrs() {
      return {
        style: {
          marginLeft: '12px'
        }
      };
    }
  }),

  methods: {
    copyAction: function copyAction(item) {
      if (item.type === 'free') {
        return {
          createRequest: this.handleCopyPSTmpl
        };
      }
      return {};
    },
    handleCopyPSTmpl: function handleCopyPSTmpl(params) {
      var _this = this;

      return _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee() {
        var res, code, errorMsg, _$get, id;

        return _regeneratorRuntime.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                _context.prev = 0;

                params.source = 'gm';
                _context.next = 4;
                return createPSProject(params);

              case 4:
                res = _context.sent;
                code = _.get(res, 'code');

                if (!(code === 1)) {
                  _context.next = 12;
                  break;
                }

                errorMsg = _.get(res, 'msg');

                _this.$message.error(errorMsg);
                return _context.abrupt('return', _Promise.reject(_Object$assign({}, res, { message: errorMsg })));

              case 12:
                if (!(code === 0)) {
                  _context.next = 15;
                  break;
                }

                _$get = _.get(res, 'data'), id = _$get.id;
                // 根据 pt 格式拼接返回参数

                return _context.abrupt('return', {
                  data: {
                    data: {
                      project_id: id
                    }
                  }
                });

              case 15:
                _context.next = 20;
                break;

              case 17:
                _context.prev = 17;
                _context.t0 = _context['catch'](0);

                console.error(_context.t0);

              case 20:
              case 'end':
                return _context.stop();
            }
          }
        }, _callee, _this, [[0, 17]]);
      }))();
    },
    handleCopySuccess: function handleCopySuccess(_ref) {
      var _ref$data = _ref.data,
          data = _ref$data === undefined ? {} : _ref$data,
          type = _ref.type;
      var id = data.id;

      if (type !== 'free') {
        this.$router.push({
          name: this.creativeList[type].routerName,
          params: {
            customId: id
          }
        });
      } else {
        window.location.href = playsmartEntry + '#/workbench?id=' + id;
      }
    }
  }
};